import React from 'react'
import constant from '../../../constant'

const List = ({ stats }) => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table align-middle table-nowrap table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col" style={{ width: 70 }}>
                                            #
                                        </th>
                                        <th scope="col">Production Forms / Reports</th>
                                        <th scope="col">Statistics</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM 011a
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    New Building Pre-Launching Check List{" "}
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.preLaunchingCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingPreLaunchingCheckList.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingPreLaunchingCheckList.url}

                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.configureNewBuildingPreLaunchingCheckList.url}
                                                        title="Configure"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-cog" aria-hidden="true" />{" "}
                                                        Configure
                                                    </a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM 011b
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Pre-Sea Trial Checklist
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.preSeaTrialCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingPreSeaTrialCheckList.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingPreSeaTrialCheckList.url}
                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.configureNewBuildingPreSeaTrialCheckList.url}
                                                        title="Configure"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-cog" aria-hidden="true" />{" "}
                                                        Configure
                                                    </a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM 011c
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Pre Delivery Checklist
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.preDeliveryCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingPreDeliveryCheckList.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingPreDeliveryCheckList.url}

                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.configureNewBuildingPreDeliveryCheckList.url}
                                                        title="Configure"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-cog" aria-hidden="true" />{" "}
                                                        Configure
                                                    </a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SM 018
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Final Delivery Document Checksheet
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.finalDeliveryDocumentCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingFinalDeliveryDocumentChecksheet.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingFinalDeliveryDocumentChecksheet.url}

                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.configureNewBuildingFinalDeliveryDocumentChecksheet.url}
                                                        title="Configure"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-cog" aria-hidden="true" />{" "}
                                                        Configure
                                                    </a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SMR 001a
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Block Inspection Status
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.blockInspectionStatusCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingBlockInspectionStatus.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingBlockInspectionStatus.url}

                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            CVCD-001
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Confirmation of Vessel Completion and Delivery
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.confirmationOfVesselCompletionAndDeliveryCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingConfirmationOfVesselCompletionAndDelivery.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingConfirmationOfVesselCompletionAndDelivery.url}

                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            DIR-001
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Daily Inspection Report
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.dailyInspectionReportCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingDailyInspectionReport.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingDailyInspectionReport.url}


                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            NCR-001
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    NCR Form
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.ncrReportCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingNCR.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingNCR.url}

                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            NCRI-001
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    NCR Form Index
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.ncrIndexReportCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitNewBuildingNCRIndex.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedNewBuildingNCRIndex.url}


                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            SMR 001a
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Owner Defect Report
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.ownerDefectReportCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitOwnerDefectReport.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedOwnerDefectReport.url}

                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                            WTS-001
                                        </td>
                                        <td>
                                            <h5 className="font-size-14 mb-1">
                                                <a href="javascript:void(0);" className="text-dark">
                                                    {" "}
                                                    Weekly TimeSheet
                                                </a>
                                            </h5>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#676767" }}>{stats?.weeklyTimeSheetCount}</span>
                                            </a>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-14 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submitWeeklyTimesheet.url}
                                                        style={{ color: "#319bfc" }}
                                                        title="Create"
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
                                                        Create
                                                    </a>
                                                </li>
                                                <li className="list-inline-item px-2">
                                                    <a
                                                        href={constant.Authedcomponent.submittedWeeklyTimeSheet.url}

                                                        title="List"
                                                        style={{ color: "#319bfc" }}
                                                    >
                                                        <i className="fa fa-list" aria-hidden="true" /> List
                                                    </a>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default List